import { render, staticRenderFns } from "./UserBoxPortrait.vue?vue&type=template&id=b4a7d6c2&"
import script from "./UserBoxPortrait.vue?vue&type=script&lang=js&"
export * from "./UserBoxPortrait.vue?vue&type=script&lang=js&"
import style0 from "./UserBoxPortrait.vue?vue&type=style&index=0&id=b4a7d6c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports